module.exports = __webpack_public_path__ + "img/map-info.7fa9f493.png";